import React, { useState, useCallback } from "react";
import { Container } from "./styles";

import {Dropdown } from "semantic-ui-react";

import { producaov2 as api } from "../../../services/apis";
import _ from "underscore";

const DropdownAlunosMultiple = ({ alunos, setAlunos, disabled }) => {
  const [alunosOptions, setAlunosOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [alunoSearch, setAlunoSearch] = useState("");

  const removeRepeatedFromArrayOfObjects = (arr) => {
    return _.union(arr.map((v) => JSON.stringify(v))).map((v) => JSON.parse(v));
  };

  const handleAlunoChange = useCallback(
    (e, { options, value }) => {
      const newSelectedOptions = options.filter((option) =>
        value.includes(option.value)
      );

      setAlunos(value);

      const formatedSelectedOptions = removeRepeatedFromArrayOfObjects(
        newSelectedOptions
      );

      setSelectedOptions(formatedSelectedOptions);
    },
    [JSON.stringify(selectedOptions)]
  );

  const handleAlunoSearchChange = useCallback(
    (e) => {
      const search = e.target.value;

      api.get(`alunos?search=${search}&limit=15`).then((res) => {
        if (res.data.length > 0) {
          const options = res.data.map((pessoa, index) => ({
            key: index,
            text: `(${pessoa.email}) [ID: ${pessoa.id}]`,
            value: pessoa.id,
          }));

          const rawAlunosOptions = [...options, ...selectedOptions].map(
            (option) => {
              delete option.key;
              return option;
            }
          );

          const newAlunosOptions = removeRepeatedFromArrayOfObjects(
            rawAlunosOptions
          ).map((option, index) => ({ ...option, key: index }));

          setAlunosOptions(newAlunosOptions);
          return;
        }
        setAlunosOptions(selectedOptions);
      });
    },
    [JSON.stringify(selectedOptions)]
  );

  return (
    <Container>
      <div>
        <label>Selecione o alunos</label>
        <Dropdown
          placeholder="Busque pelo ID, Nome ou E-mail do aluno"
          fluid
          labeled
          selectedLabel={[18805]}
          multiple
          search
          selection
          options={alunosOptions}
          onChange={handleAlunoChange}
          onSearchChange={handleAlunoSearchChange}
          value={alunos}
          disabled={disabled}
        />
      </div>
    </Container>
  );
};

export default DropdownAlunosMultiple;
